export const eSignChinaEvidenceTool = {
  "sdkInitLoading": "",
  "title": "",
  "uploadFile": "",
  "resolveSuccess": "",
  "resolveFail": "",
  "resolveNothing": "",
  "copyText": "",
  "uploadFilePrimaryTooltips": "",
  "uploadFileTooltips": "",
  "evidenceChainID": "",
  "oriHash": "",
  "signedHash": "",
  "copySuccess": "",
  "copyFail": "",
  "currentDoc": "",
  "notExistChainID": "",
  "flowSignIsDoing": "",
  "hash": ""
}